<!-- 创新100+ -->
<template>
    <div class="invate">
        <div class="invate-btn" @click="handleshowCX">创新100+</div>
       <data-swiper v-if="showCX" @close="handleCloseCX"></data-swiper>
    </div>
</template>
<script>
 


import dataSwiper from "./dataSwiper.vue";
export default {
    name: "innvate",
    components: {
        
        dataSwiper
    },

 
    data() {
        return {
         
            showCX: false,
            
        }
    },
    methods: {
      
        handleshowCX() {
            this.showCX = true;
            /* 点击传递埋码 */
            window.goldlog.record("/spec.1.1", "", "snsScene=创新100+&product=pcweb&pagename=云上2024年品博会", "");
        },
        handleCloseCX() {
   
            this.showCX = false;
        }
    },

    
}
</script>
<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.invate {
    .invate-btn {
        width: 182px;
        height: 62px;
        line-height: 55px;
        cursor: pointer;
        text-align: center;
        color: #ffffff;
        font-size: 20px;
        position: absolute;
        right: 84px;
        bottom: 60px;
        background-image: url("../../assets/img/btn-bg.png");
        @include background-com();
    }

   
}
</style>
 